export default "__VITE_ASSET__a656c80b__"